import { createApiService } from './api'
import { createAxios } from './axios'

export const axiosInstance = createAxios(window.location.protocol + '//' + window.location.host)

export const api = createApiService(axiosInstance)
